module.exports = __webpack_public_path__ + "static/media/email-confirmation.439e6657.svg";